import { type ReferralsState } from "./state";

export const initialState: ReferralsState = {
  referrals: [],
  originationUrl: "",
  referralCode: "",
  isPending: false,
  isRejected: false,
  errorMessage: "",
  isCreating: false,
  createError: "",
};
